function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-107.999 -301.5)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Path 11233",
  fill: "#f2f5ff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M108.499 313.324a11.25 11.25 0 0 1 3.316-8.007 11.25 11.25 0 0 1 8.007-3.317 11.25 11.25 0 0 1 8.007 3.317 11.25 11.25 0 0 1 3.317 8.007c0 2.529-1.988 5.793-5.75 9.44a53.455 53.455 0 0 1-5.574 4.665 53.455 53.455 0 0 1-5.573-4.665c-3.762-3.647-5.75-6.911-5.75-9.44z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.646 313.324c0-2.891-1.126-5.61-3.17-7.654a10.753 10.753 0 0 0-7.654-3.17c-2.89 0-5.609 1.126-7.653 3.17a10.753 10.753 0 0 0-3.17 7.654c0 2.388 1.932 5.525 5.588 9.072 2.11 2.046 4.245 3.685 5.235 4.414.99-.73 3.126-2.368 5.235-4.414 3.656-3.547 5.589-6.684 5.589-9.072m1 0c0 6.53-11.824 14.719-11.824 14.719S108 319.853 108 313.323c0-6.53 5.293-11.823 11.823-11.823s11.824 5.294 11.824 11.824z",
  fill: "#b2b3b5"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 11244",
  d: "M129 313.5c0 4.971-9 11.2-9 11.2s-9-6.229-9-11.2a9 9 0 0 1 18 0z",
  fill: "#cbcfe3"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 1131",
  cx: 5,
  cy: 5,
  r: 5,
  transform: "translate(115 308.5)",
  fill: "#fff"
}));

function SvgStepperGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.647,
    height: 26.543,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperGrey);
export default __webpack_public_path__ + "static/media/stepper-grey.0c86f2dc.svg";
export { ForwardRef as ReactComponent };